import React from "react";
import Translate from "react-translate-component";
export const ShortOrderCancel = ({
  op,
  changeColor
}) => {
  changeColor("cancel");
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
    component: "span",
    content: "proposal.short_order_cancel"
  }), "\xA0", op[1].order);
};